import { useTitle } from 'react-use';
import type { ReactNode } from 'react';

export interface DocumentTitleProps {
  /** Нестроковые значения игнорируются (typeof-проверка внутри) — DataTablePage
   *  передаёт сюда header, который бывает ReactNode. */
  title?: ReactNode;
}

const DocumentTitle = (props: DocumentTitleProps) => {
  if (typeof props.title !== 'string') return null;
  useTitle(props.title);
  return null;
};

export default DocumentTitle;
